import template from './plain-rooms-count.jade';
import plainRoomsCount from './../../../enums/plain-rooms-count';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular.module('cian.addForm.plainRoomsCount', []).directive('cianAfAboutObjectPlainRoomsCount', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    'adTooltipsService',
    '$scope',
    'analyticsService',
    'deviceService',
    'popupService',
    'store',
    function (adTooltipsService, $scope, analyticsService, deviceService, popupService, store) {
      this.isMobile = deviceService.isMobile;
      this.modalHintTitle = 'Всего комнат в квартире';
      if (this.ad.roomsCount && this.ad.roomsCount < 2) {
        delete this.ad.roomsCount;
      }
      this.items = plainRoomsCount.filter(item => item.value !== 1);
      this.ad.flatType = 'rooms';

      this.handleChange = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        trackRequiredFieldFill(category, 'total_number_of_rooms');
      };

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'roomsCount',
        trackingLabel: 'plain-rooms-count-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },
  ],
  controllerAs: 'plainRoomsCount',
  template,
})).name;
